"use client";
import Image from "next/image";

const TitleHeading = ({
  imageSrc,
  imageAlt,
  heading,
  subheading,
  linkText,
  linkHref,
}) => {
  return (
    <div>
      <section className="relative py-10 md:py-20 lg:py-40 -z-20 before:-z-10 before:bg-opacity-20">
        {/* Background Image using Next.js Image tag */}
        <Image
          src={imageSrc}
          alt={imageAlt}
          fill
          className="absolute top-0 left-0 w-full h-full -z-10 object-cover"
        />

        {/* Overlay */}
        <div className="absolute inset-0 bg-black opacity-50 z-0"></div>

        <div className="max-w-screen-xl mx-5 lg:mx-auto relative z-10">
          <div className="grid grid-cols-1 gap-3 items-center justify-between text-gray-300">
            {/* Heading and content */}
            {heading && (
              <h1 className="font-bold text-white text-3xl lg:text-5xl mb-3">
                {heading}
              </h1>
            )}
            {/* {subheading && (
              <p className="text-white text-lg">
                {linkText && linkHref ? (
                  <a
                    href={linkHref}
                    className="text-orange-600 hover:text-orange-300"
                  >
                    {linkText}
                  </a>
                ) : null}
                {subheading}
              </p>
            )} */}
          </div>
        </div>
      </section>
    </div>
  );
};

export default TitleHeading;
